import React, { Component } from 'react';
import DateTimePicker from './DateTimePicker';
import StaticTextInput from './StaticTextInput'
import './DateTimeInput.css';

/**
 * @deprecated Use FormInput or DateTimePicker instead.
 */
export default class DateTimeInput extends Component {

    render() {
        if(this.props.readonly) {
            return <StaticTextInput label={this.props.label} value={this.props.value && this.props.value.toString()} />
        }

        return (
            <div className="form-group">
                <label className="col-xs-4 control-label">{this.props.label}</label>
                <div className="col-xs-8">
                    <DateTimePicker
                        value={this.props.value}
                        onChange={this.props.onChange}
                        dateFormat={this.props.dateFormat}
                        showTime={this.props.showTime}
                        placeholderText={this.props.placeholderText}
                        closeOnSelect={this.props.closeOnSelect}
                        isValidDate={this.props.isValidDate}
                        showTimezone={this.props.showTimezone}
                    />
                </div>
            </div>
        );
    }
}